export const Hotel = {
    AVILABLE_URL: "HOTEL/AVAILABLEROOMS",
    RESERVE_URL: "BOOKING/RESERVE",
    TICKET_URL: "BOOKING/TICKETBYRESERVENUMBER",
    VOUCHER_URL: "BOOKING/VOUCHERBYRESERVENUMBER",
    CREDITBOOK_URL: "BOOKING/CREDITBOOK",
    GETCREDIT_URL: "PROFILE/GetCreditsBySourceId",
    CREATEVOUCHER_URL: "BOOKING/VoucherHtml",


};

export const Flight = {
    AVILABLE_URL: "FLIGHT/FLIGHTAVAILABILITY",
    INITIAL_RESERVE_URL: "FLIGHT/FLIGHTPRERESERVE",
};